import React from 'react';
// import {Router, Route, Switch} from 'react-router-dom';
import { HashRouter ,Route, Switch, withRouter }from 'react-router-dom';
import index from './pages/index/index.jsx'
import download from './pages/download/download.jsx'
import Register from './pages/register/register.jsx';
import Login from './pages/login/login.jsx';
import solve_plan from './pages/solve_plan/solve_plan.jsx';
import consult from './pages/solve_plan/consult.jsx';
import menjin from './pages/menjin/menjin.jsx';
import inputSecret from './pages/inputSecret/inputSecret.jsx';
class Home extends React.Component {
    // constructor(props) {
    //     super(props);
    // }
    render(){
      return(
        // <HashRouter history={this.props.history}>
          <Switch>
            <Route component={download} path='/download' exact/>
            <Route component={Register} path='/register' exact/>
            <Route component={Login} path='/login' exact/>
            <Route component={solve_plan} path='/solve_plan' exact/>
            <Route component={consult} path='/consult' exact/>
            <Route component={menjin} path='/menjin' exact/>
            <Route component={inputSecret} path='/inputSecret' exact/>
            <Route path='/' exact component={index} />
          </Switch>
        // </HashRouter>
     )
    }
  }
  export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/router.js